import React, { useCallback, useEffect, useState } from 'react'
import ContainerLayout from '../../../components/container-layout/ContainerLayout'
import { useTranslation } from 'react-i18next';
import ContainerButton from '../../../components/button/ContainerButton';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckBoxCustom from '../../../components/checkbox/CheckBoxCustom';
import { ButtonContained } from '../../../components/button/ButtonCustoms';
import SettingsIcon from '@mui/icons-material/Settings';
import StateComponents from '../../../components/state-component/StateComponents';
import ModalCustom from '../../../components/modal/ModalCustom';
import { handleTypingNumber } from '../../../utils/app.utils';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { degreeApi } from '../../../api/degree/degree.api';
import { CourseOfStudyApi } from '../../../api/course-of-study/course-of-study.api';
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom';
import { alertError, alertSuccess } from '../../../components/alert/swal';
import { AcademicYearApi } from '../../../api/academic-year/academic-year.api';
import { routeName } from '../../../routes/routeName';
export default function SetupCourseOpeningDetail(props:any) {
    const { t } = useTranslation();
    const { id } = useParams()
    const {view} = props
    const navigate: NavigateFunction = useNavigate();

    // const [form, set_form] = useState<any>([])
    const [selected, setSelected] = useState<any[]>([])
    const [showModal, setShowModal] = useState<string>("");
    const dispatch = useDispatch();
    const [data, setData] = useState<any[]>([]);
    const [editItem, setEditItem] = useState<any | null>(null);
    const [form, setForm] = useState<any>();
    const [detail, setDetail] = useState<any>();
    const [item, setItem] = useState<any>();
    const isSelected = (degreeId: number, facultyId?: number) => {
        return selected.some(
            (s: any) => s.id_degree === degreeId && s.id_faculty === (facultyId ?? 0)
        );
    };
    const toggleSelect = (degreeId: number, facultyId?: number) => {
        setSelected((prev) => {
            const exists = prev.some(
                (s) => s.id_degree === degreeId && s.id_faculty === (facultyId ?? 0)
            );

            if (exists) {
                // ถ้ามีอยู่แล้ว ลบออก
                return prev.filter(
                    (s) => !(s.id_degree === degreeId && s.id_faculty === (facultyId ?? 0))
                );
            } else {
                // ถ้ายังไม่มี เพิ่มเข้าไป
                return [
                    ...prev,
                    {
                        id_course_of_study: 0,
                        id_degree: degreeId,
                        id_faculty: facultyId ?? 0,
                        status: "active",
                        setting: { room: "", price_bath: 0, price_usd: 0 },
                    },
                ];
            }
        });
    };
    const toggleSelectAll = (degreeId: number, faculties: any[]) => {
        setSelected((prev) => {
            const allSelected = faculties.every((f) =>
                prev.some((s) => s.id_degree === degreeId && s.id_faculty === f.id_faculty)
            );

            if (allSelected) {
                // ถ้าเลือกครบแล้ว → ยกเลิกทั้งหมด
                return prev.filter((s) => s.id_degree !== degreeId);
            } else {
                // ถ้ายังไม่ครบ → เลือกทั้งหมด
                const others = prev.filter((s) => s.id_degree !== degreeId);
                const newOnes = faculties.map((f) => ({
                    id_course_of_study: 0,
                    id_degree: degreeId,
                    id_faculty: f.id_faculty,
                    status: "active",
                    setting: { room: "", price_bath: 0, price_usd: 0 },
                }));
                return [...others, ...newOnes];
            }
        });
    };
    const handleCloseModal = () => {
        setShowModal("");
        // set_id_gallery_type(null);
        setForm(null)
    }
    const handleGetData = useCallback(async () => {
        let query: any = {

        }
        // if (keyword) query = { ...query, search: keyword }
        // if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        // if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }
        dispatch(setLoading());
        await degreeApi.tree(query).then((res) => {
            if (res.status < 300) {
                setData(res.data?.data || []);
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [])
    useEffect(() => {
        handleGetData()
    }, [handleGetData])

    const getDetail = async () => {
        await CourseOfStudyApi.academicDetail(id).then((res) => {
            if (res.status < 300) {
                setSelected(res.data?.data?.map((item: any) => {
                    return {
                        ...item,
                        setting: {
                            room: item?.room,
                            price_bath: item?.price_bath,
                            price_usd: item?.price_usd
                        }
                    }
                }))
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const getAcademicYearDetail = async () => {
        await AcademicYearApi.getAcademicYearById(Number(id)).then((res) => {
            if (res.status < 300) {
              setDetail(res.data.data);
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    useEffect(() => {
        getDetail()
        getAcademicYearDetail()
    }, [])
    const handleSaveSetting = () => {
        if (!editItem) return;

        setSelected((prev) =>
            prev.map((s) => {
                if (s.id_degree === editItem.degreeId && s.id_faculty === editItem.facultyId) {
                    return {
                        ...s,
                        setting: {
                            room: form.room,
                            price_bath: Number(form.price_bath),
                            price_usd: Number(form.price_usd),
                        },
                    };
                }
                return s;
            })
        );

        setShowModal('');
        setEditItem(null);
    };
    const handleSubmit = async () => {
        const body = selected
        dispatch(setLoading());

        await CourseOfStudyApi.academicCreate(body, id)
            .then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("SETUP_COURSE_OPENING_SAVE"), t("SETUP_COURSE_OPENING_SAVE_COMPLETED"));
                    // setDisabled(true)
                }
            })
            .catch((err) => {
                console.log(err);
                alertError(t("SETUP_COURSE_OPENING_SAVE"), t("SETUP_COURSE_OPENING_SAVE_FAILED"));
            })
            .finally(() => {
                dispatch(unsetLoading());
            });
    }
    return (
        <div className='w-full'>
            <ContainerLayout
                title={`${t('SETUP_COURSE_OPENING_ACADEMIC_YEAR')} ${detail?.academic_year}`}

                content={
                    <div className='w-full'>

                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {data?.map((item: any) => {
                                return (
                                    <Accordion defaultExpanded sx={{
                                        backgroundColor: "#4A4A4A", color: "white",
                                        // borderRadius: "18px",
                                        overflow: 'hidden'
                                    }}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                            sx={{
                                                backgroundColor: "#4A4A4A",
                                                padding: "10px 16px",
                                                fontWeight: "bold",
                                                margin: '0px',
                                                "& .MuiAccordionSummary-content": {
                                                    margin: '0px'
                                                },
                                                "& .MuiAccordionSummary-content.Mui-expanded": {
                                                    margin: '0px'
                                                }
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }} onClick={(e) => e?.stopPropagation()}>
                                                <CheckBoxCustom checked={item.faculty.every((f: any) => isSelected(item.id_degree, f.id_faculty))}
                                                    setChecked={() => toggleSelectAll(item.id_degree, item.faculty)} />
                                                <Typography sx={{ fontWeight: "bold", color: '#fff' }}>{`${item?.degree_name_eng} (${item?.degree_name})`}</Typography>
                                            </Box>

                                        </AccordionSummary>
                                        <AccordionDetails sx={{ backgroundColor: "#fff", color: "black", display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                            {item?.faculty?.length > 0 ? item?.faculty?.map((obj: any, i: number) => {
                                                return (
                                                    <Box sx={{ display: 'flex', alignItems: 'center', padding: '10px', justifyContent: 'space-between' }} >
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                            <CheckBoxCustom
                                                                checked={isSelected(item.id_degree, obj.id_faculty)}
                                                                setChecked={() => toggleSelect(item.id_degree, obj.id_faculty)} />
                                                            <Typography>{`${obj?.faculty_name_eng} (${obj?.faculty_name})`}</Typography>
                                                        </Box>
                                                       {selected?.find((item:any) => item?.id_faculty === obj.id_faculty) && <ButtonContained iconComponent={<SettingsIcon />} buttonName={t('SETUP_COURSE_OPENING_SETUP')} btnProps={{
                                                            bg: '#F79009'
                                                        }} onClick={() => {
                                                            setShowModal('ADD')
                                                            setItem({...item, ...obj})
                                                            setEditItem({ degreeId: item.id_degree, facultyId: obj.id_faculty });
                                                            setForm({
                                                                room: selected?.find((item:any) => item?.id_faculty === obj.id_faculty)?.setting?.room ?? "",
                                                                price_bath: selected?.find((item:any) => item?.id_faculty === obj.id_faculty)?.setting?.price_bath ?? 0,
                                                                price_usd: selected?.find((item:any) => item?.id_faculty === obj.id_faculty)?.setting?.price_usd ?? 0,
                                                            });
                                                        }} disabled={view} />}

                                                    </Box>
                                                )
                                            }) : <Typography>{t('SETUP_COURSE_OPENING_NO_DATA')}...</Typography>}

                                        </AccordionDetails>
                                    </Accordion>
                                )
                            })}

                        </Box>

                        <ContainerButton
                            sxContainer={{ my: 3 }}
                            buttonData={[
                                {
                                    seq: 1,
                                    buttonProps: {
                                        onClick: () => {navigate(routeName.admission.SetupCourseOpening)},
                                    },
                                    key: "CANCEL",
                                    label: t("SETUP_COURSE_OPENING_BACK"),
                                    type: "CANCEL"
                                },

                                {
                                    seq: 2,
                                    buttonProps: {
                                        onClick: () => {
                                            handleSubmit()
                                        }
                                    },
                                    hidden: view,
                                    key: "SEND",
                                    label: t("SETUP_COURSE_OPENING_CONFIRM"),
                                    type: 'SAVE'
                                },

                            ]}
                        />
                    </div>
                }
            />
            {showModal !== '' && (
                <ModalCustom
                    open
                    title={t('SETUP_COURSE_OPENING_SETUP')}
                    subTitle={t("SETUP_COURSE_OPENING_COMPLETE_INFO_REQUIRED")}
                    onClose={handleCloseModal}
                    containerButton={{
                        disabled_submit: !form.room,
                        // hidden_submit: showModal === 'VIEW',
                        onClose: handleCloseModal,
                        onSubmit: () => handleSaveSetting()
                    }}
                    component={
                        <div className='w-full'>
                            <Typography>{t('SETUP_COURSE_OPENING_ACADEMIC_YEAR')} {detail?.academic_year}</Typography>
                            {/* <Typography>{selected?.find((item:any) => item?.id_faculty === editItem.id_faculty)}</Typography> */}
                            <Typography>{`${item?.degree_name_eng} (${item?.degree_name})`}</Typography>
                            <Typography>{`${item?.faculty_name_eng} (${item?.faculty_name})`}</Typography>
                            <StateComponents
                                disabledAllField={showModal === "VIEW"}
                                otherProps={{ spacing: 2 }}
                                sxContainer={{ marginTop: "10px" }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: { xs: 12 },
                                        fieldProps: {
                                            heading: t("SETUP_COURSE_OPENING_ROOM_COUNT"),
                                            required: true,
                                            value: form?.room,
                                            onChange: (e: any) => setForm((prev: any) => ({ ...prev, room: e.target.value })),
                                            onkeypress: handleTypingNumber,
                                        },
                                    },
                                    {
                                        seq: 2,
                                        type: "TEXT_FIELD",
                                        gridProps: { xs: 12 },
                                        fieldProps: {
                                            heading: t("SETUP_COURSE_OPENING_APPLICATION_FEE"),
                                            required: true,
                                            value: form?.price_bath,
                                            onChange: (e: any) => setForm((prev: any) => ({ ...prev, price_bath: e.target.value })),
                                            onkeypress: handleTypingNumber,
                                        },
                                    },
                                    {
                                        seq: 3,
                                        type: "TEXT_FIELD",
                                        gridProps: { xs: 12 },
                                        fieldProps: {
                                            heading: t("SETUP_COURSE_OPENING_APPLICATION_FEE_USD"),
                                            required: true,
                                            value: form?.price_usd,
                                            onChange: (e: any) => setForm((prev: any) => ({ ...prev, price_usd: e.target.value })),
                                            onkeypress: handleTypingNumber,
                                        },
                                    },
                                ]}
                            />
                            {/* <StateComponents
                                disabledAllField={showModal === 'VIEW'} otherProps={{ spacing: 2 }} sxContainer={{ marginTop: '10px' }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                        },
                                        fieldProps: {
                                            heading: t("จำนวนห้อง"),
                                            required: true,
                                            value: form?.room,
                                            onChange: (e) => { },
                                            onkeypress: handleTypingNumber
                                        }
                                    },
                                    {
                                        seq: 2,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                        },
                                        fieldProps: {
                                            heading: t("ค่าสมัคร (THB)"),
                                            required: true,
                                            value: form?.price_bath,
                                            onChange: (e) => { },
                                            onkeypress: handleTypingNumber
                                        }
                                    },
                                    {
                                        seq: 3,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                        },
                                        fieldProps: {
                                            heading: t("ค่าสมัคร (USD)"),
                                            required: true,
                                            value: form?.price_usd,
                                            onChange: (e) => { },
                                            onkeypress: handleTypingNumber
                                        }
                                    },


                                ]}
                            /> */}
                        </div>
                    }
                />
            )}
        </div>
    )
}
